import React from 'react'
import { PiWalletLight } from 'react-icons/pi'
import { IoTimeOutline } from 'react-icons/io5'
import { GoArrowUpRight } from 'react-icons/go'
import Link from 'next/link'
import { whatsappUrl } from '@/services/common'

export default function ExperienceImgHeader({
  name = '',
  amount = '',
  time = '',
  className = '',
  layout = 'horizontal', // "horizontal" for USD, "vertical" for EGP
}: {
  name: string
  amount: string
  time: string
  className: string
  layout: 'horizontal' | 'vertical'
}) {
  return (
    <div
      className={`absolute inset-0 bg-gradient-to-t from-black/60 to-transparent text-white flex justify-between items-start ${className}`}
    >
      {/* Left side - Name, Amount, Time */}
      <div className='flex items-start gap-1 flex-col'>
        <h3 className='text-[16px] font-semibold line-clamp-1 text-start'>
          {name}
        </h3>

        {layout === 'vertical' ? (
          // Vertical layout for EGP (more space)
          <div className='text-sm text-[#FFFFFFCC] flex flex-col gap-1'>
            <span className='flex items-center gap-1 whitespace-nowrap overflow-hidden text-ellipsis'>
              <PiWalletLight className='text-[20px] font-bold flex-shrink-0' />
              <span className='overflow-hidden text-ellipsis'>{amount}</span>
            </span>
            <span className='flex items-center gap-1 whitespace-nowrap overflow-hidden text-ellipsis'>
              <IoTimeOutline className='text-[18px] font-bold flex-shrink-0' />
              <span className='overflow-hidden text-ellipsis'>{time}</span>
            </span>
          </div>
        ) : (
          // Horizontal layout for USD (compact)
          <p className='text-sm text-[#FFFFFFCC] flex items-center gap-2.5 overflow-hidden'>
            <span className='flex items-center gap-1 whitespace-nowrap overflow-hidden text-ellipsis min-w-0'>
              <PiWalletLight className='text-[20px] font-bold flex-shrink-0' />
              <span className='overflow-hidden text-ellipsis text-[#FFFFFFCC]'>
                {amount}
              </span>
            </span>
            <span className='flex items-center gap-1 whitespace-nowrap overflow-hidden text-ellipsis min-w-0'>
              <IoTimeOutline className='text-[18px] font-bold flex-shrink-0' />
              <span className='overflow-hidden text-ellipsis text-[#FFFFFFCC]'>
                {time}
              </span>
            </span>
          </p>
        )}
      </div>

      {/* Right side - WhatsApp button (Accessible) */}
      <Link
        target='_blank'
        href={whatsappUrl}
        aria-label='Contact via WhatsApp'
        className='shrink-0'
      >
        <span
          className='bg-white/20 p-2.5 rounded-full inline-flex items-center justify-center'
        >
          <GoArrowUpRight className='text-[20px] font-bold text-white' />
        </span>
      </Link>
    </div>
  )
}
